import md5 from 'md5';
import uniqid from 'uniqid';

const makeDeviceID = () => md5(navigator.userAgent + uniqid());

export default makeDeviceID;
